module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_request_003_lg-e83b79c5.png";